import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

import SubscriptionContextProvider from './context/SubscriptionContextProvider';

const PageRoot = lazy(() => import('@app/components/PageRoot'));
const SubscriptionPage = lazy(() => import('.'));

class SubscriptionPageWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['team-uuid'];
    }

    render() {
        const teamUuid = this.prop('team-uuid');

        return (
            <PageRoot>
                <SubscriptionContextProvider>
                    <SubscriptionPage teamUuid={teamUuid} />
                </SubscriptionContextProvider>
            </PageRoot>
        );
    }
}

customElements.define('subscription-page', SubscriptionPageWebComponent);
